module.exports = __webpack_public_path__ + "static/Creator 18 - @RoyzaGaming-1fbc834bccf2716b3a9fd8dacef69b3e.png";